"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

/**
 * @since 2016-08-06 15:57
 * @author vivaxy
 */

exports.default = function (timeout) {
    return new Promise(function (resolve) {
        setTimeout(resolve, timeout);
    });
};


//////////////////
// WEBPACK FOOTER
// ./~/@dp/cmp-prototype-lib/lib/sleep.js
// module id = 235
// module chunks = 0